export const ShopTabs = ['permanent', 'temporary',
  // 'skins'
] as const;
